import React from "react";
import styled from "styled-components";
import { getBackgroundColor } from "../CareConnectMobile-Theme";

export interface Props extends React.HTMLAttributes<HTMLElement> {
  /** Lets flex container grow */
  flexgrow?: string;
  /** Maximize the width of the container */
  maximize?: boolean;
  /** Set flex value of item */
  flex?: boolean;
  /** Set minimum with of item, used to make big content scale to small divs */
  minWidth?: string;
  /** Set the overflow attribute */
  overflow?: string;
  /** Skin of the brand name and product name */
  colorTheme?: "light" | "dark";
}

/**
 * Flexbox helper classes enable you to quickly layout items in relation to each other.
 */
const FlexItem = ({
  flex,
  flexgrow,
  maximize,
  children,
  minWidth,
  overflow,
  colorTheme,
  ...props
}: Props) => {
  return <div {...props}>{children}</div>;
};

export default styled(FlexItem)<Props>`
  ${(props) => props.maximize && `width: 100%;`}
  ${(props) => props.flexgrow && `flex-grow:` + props.flexgrow}
  ${(props) => props.flexgrow && props.flexgrow !== "0" && `min-height: 0`}
  ${(props) => props.flexgrow && props.flexgrow !== "0" && `height: 100%`}
  ${(props) => props.flex && `display: flex`}
  ${(props) => props.minWidth && `min-width:` + props.minWidth} 
  ${(props) => props.overflow && `overflow:` + props.overflow} 
  background-color: ${getBackgroundColor};
  ${(props) => props.colorTheme && `color: white`}
`;
